// src/components/orders/BundleItemGroup/BundleItemGroup.jsx
import React from 'react';
import { Hash } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import BundleBadge from '../../ui/BundleBadge/BundleBadge';
import styles from './BundleItemGroup.module.css';

// Read-only bundle group. The host passes renderItem so component rows keep the host's own markup.
const BundleItemGroup = ({ group, variant = 'table', columns = 5, renderItem }) => {
  const { t, formatCurrency } = useLocalization();
  const name = group.bundleName || t('ecomOrders.bundle');
  const qty = Number(group.bundleQuantity) || 1;

  if (variant === 'compact') {
    return (
      <div className={styles.compactGroup}>
        <div className={styles.compactName}>{name}</div>
        {group.bundleSku && <div className={styles.compactSku}><Hash size={11} />{group.bundleSku}</div>}
        <div className={styles.compactFields}>
          <BundleBadge variant="list" />
          <div className={styles.compactField}>
            <span className={styles.compactLabel}>{t('ecomOrders.bundleQuantity') || 'Bundle Qty'}</span>
            <span className={styles.groupQty}>× {qty}</span>
          </div>
          <div className={`${styles.compactField} ${styles.compactFieldEnd}`}>
            <span className={styles.compactLabel}>{t('ecomOrders.bundleTotal') || 'Bundle Total'}</span>
            <span className={styles.groupTotal}>{formatCurrency(group.total)}</span>
          </div>
        </div>
        <div className={styles.compactItemsHeader}>
          <span>{t('ecomOrders.item') || 'Item'}</span>
          <span>{t('ecomOrders.quantity') || 'Quantity'} / {t('ecomOrders.lineTotal') || 'Line Total'}</span>
        </div>
        <div className={styles.compactItems}>
          {group.items.map((item, idx) => renderItem(item, idx))}
        </div>
      </div>
    );
  }

  return (
    <>
      <tr className={styles.groupRow}>
        <td colSpan={columns - 1}>
          <div className={styles.groupHeader}>
            <span className={styles.groupName}>{name}</span>
            <BundleBadge size={10} />
            <span className={styles.groupQty}>× {qty}</span>
          </div>
        </td>
        <td className={styles.groupTotalCell}>
          <strong>{formatCurrency(group.total)}</strong>
        </td>
      </tr>
      {group.items.map((item, idx) => renderItem(item, idx, styles.componentRow))}
    </>
  );
};

export default BundleItemGroup;
